export default __webpack_public_path__ + "static/media/icon_peruskriteerit_lukittu.9e48d481.svg";